import menuItems from "./menuItems.json";
import layout from "./layout.json";
import notificationMenu from "./notificationMenu.json";
import requestSizeError from "./requestSizeError.json";
import fileMenu from "./fileMenu.json";
import contents from "./contents.json";
import assetInfo from "./assets/info.json";
import assetDialog from "./assets/dialog.json";
import assetPreview from "./assets/preview.json";
import createSolutions from "./createSolutions.json";
import supportCaseActionMenu from "./supportCases/actionMenu.json";
import supportCaseAssign from "./supportCases/assign.json";
import supportCaseAssignEmail from "./supportCases/assignEmail.json";
import supportCaseAssignRelatedCases from "./supportCases/assignRelatedCases.json";
import supportCaseConversations from "./supportCases/conversations.json";
import supportCaseList from "./supportCases/list.json";
import supportCaseReminder from "./supportCases/reminder.json";
import supportCaseSettings from "./supportCases/settings.json";
import supportCaseSidebar from "./supportCases/sidebar.json";
import mentionInput from "./mentionInput.json";

export default {
  menuItems,
  layout,
  notificationMenu,
  requestSizeError,
  fileMenu,
  contents,
  assets: {
    info: assetInfo,
    dialog: assetDialog,
    preview: assetPreview,
  },
  createSolutions,
  supportCases: {
    actionMenu: supportCaseActionMenu,
    assign: supportCaseAssign,
    assignMenu: supportCaseAssignEmail,
    assignRelatedCases: supportCaseAssignRelatedCases,
    conversations: supportCaseConversations,
    list: supportCaseList,
    reminder: supportCaseReminder,
    settings: supportCaseSettings,
    sidebar: supportCaseSidebar,
  },
  mentionInput,
};
